import { Injectable } from "@angular/core";
import { ServiceMessageBroker } from "shared/provider-webworker";
import { BasePrimaryActionService } from "./BasePrimaryActionService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LockForFwdRollRequestImpl } from "shared/cubiq-model-multi-asset/model/impl/LockForFwdRollRequestImpl";
import { CubiqWorker } from "shared/cubiq-services/worker/CubiqWorker";

@Injectable()
export class FwdRollPriceActionService extends BasePrimaryActionService {
  protected broker: ServiceMessageBroker;

  constructor(private worker: CubiqWorker, public translateService: TranslateService) {
    super();
  }

  public lockForPricing(diEventId: string, portfolioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (portfolioId) {
        let request = new LockForFwdRollRequestImpl();
        request.portfolioId = portfolioId;
        this.worker.postServiceRequest(request).then((response) => {
          if (response instanceof CubiqTS.FwdRollPricingDataImpl) {
            resolve(response);
          } else {
            logger.out.warn(`Lock for Pricing failed: ${request?.toString()}`);
            reject(response);
          }
        });
      } else {
        reject("Fwd-roll-Action: [LOCK]: Missing input parameter ()");
      }
    });
  }

  public unlock(portfolioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (portfolioId) {
        let request = new CubiqTS.UnlockFwdRollRequestImpl();
        request.portfolioId = portfolioId;
        this.worker.postServiceRequest(request).then((response) => {
          if (response instanceof CubiqTS.ErrorsImpl) {
            logger.out.warn(`Unlock failed: ${response.toString()}`);
            reject(response);
          } else {
            resolve(response);
          }
        });
      } else {
        reject("Fwd-roll-Action: [UNLOCK]: Missing input parameter ()");
      }
    });
  }

  public updatePriceRequest(request: CubiqTS.FwdRollChangeRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.worker.postServiceRequest(request).then((response) => {
        if (response instanceof CubiqTS.ErrorsImpl) {
          logger.out.warn(`Unlock failed: ${response.toString()}`);
          reject(response);
        } else {
          resolve(response);
        }
      });
    });
  }

  public submitPricing(pricingRequest): Promise<any> {
    return this.worker.postServiceRequest(pricingRequest);
  }

  public clear(portfolioIds: string[]): Promise<any> {
    let request: CubiqTS.PortfolioClearForwardPriceRequestImpl = null;

    request = new CubiqTS.PortfolioClearForwardPriceRequestImpl();
    request.portfolioIds = portfolioIds;

    return this.worker.postServiceRequest(request);
  }

  public retry(portfolioIds: string[]): Promise<any> {
    let request: CubiqTS.PortfolioRetryForwardPriceRequestImpl = null;

    request = new CubiqTS.PortfolioRetryForwardPriceRequestImpl();
    request.portfolioIds = portfolioIds;

    return this.worker.postServiceRequest(request);
  }

  public savePricing(saveRequest): Promise<any> {
    return this.worker.postServiceRequest(saveRequest);
  }
}
